import React from "react";
import ContentBox from "../../Box/ContentBox/ContentBox";
import { Box, Button, Link, Rating, Typography } from "@mui/material";
import iconReview from "../../../assets/icons/serviceOverview/IconReview";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys, updateResource } from "../../../services/reactQuery/reactQueryService";
import { getThirdPartyCustomerRatingPlatform } from "../../../services/customerFeedbackService";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { CustomerFeedback } from "../../../types/Entities/CustomerFeedback";
import { parseIdFromIri } from "../../../services/utils";

type CustomerFeedbackProvenExpertBoxProps = {
  customerFeedback: CustomerFeedback;
  product: AbstractCase;
};

export default function CustomerFeedbackProvenExpertBox({ customerFeedback, product }: CustomerFeedbackProvenExpertBoxProps) {
  const updateMutation = useMutation({
    mutationFn: updateResource,
  });
  const queryClient = useQueryClient();
  const { ratingPlatform, ratingPlatformLink } = getThirdPartyCustomerRatingPlatform(parseIdFromIri(customerFeedback.case));

  const hideBox = async () => {
    await updateMutation.mutateAsync({
      uri: "/customer_feedbacks",
      id: customerFeedback.id,
      data: { showProvenExpertRatingRequest: false },
    });

    await queryClient.invalidateQueries({
      queryKey: queryKeys.collection("/customer_feedbacks", {
        source: "fullReview",
        case: `/abstract_cases/${product.id}`,
      }),
    });
  };

  return (
    <ContentBox icon={iconReview} headline={"Danke für Ihre Bewertung!"}>
      <Box sx={{ textAlign: "center", marginBottom: 1 }}>
        <Rating name="stars" value={5} size="large" disabled />
      </Box>
      <Typography
        sx={{
          color: "primary.main",
          fontWeight: 700,
          textAlign: "center",
          marginBottom: "16px"
        }}>
        Helfen Sie jetzt auch anderen Kunden, sich zu orientieren!
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          marginBottom: "16px"
        }}>
        Über das Bewertungsportal {ratingPlatform} können Sie die Unterstützung durch Legalbird öffentlich sichtbar darstellen und bewerten.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          marginBottom: "16px"
        }}>
        Dies dauert nur eine Minute und hilft anderen Rechtsuchenden bei der Auswahl der richtigen Kanzlei.
      </Typography>
      <Button
        fullWidth
        component={Link}
        href={ratingPlatformLink}
        variant={"contained"}
        target={"_blank"}
        onClick={hideBox}
        sx={{ marginBottom: "1rem", textAlign: "center" }}
      >
        Auf {ratingPlatform} bewerten
      </Button>
      <Typography
        sx={{
          textAlign: "center",
          marginBottom: "16px"
        }}>
        Wir bedanken uns im Voraus und unterstützen Sie in Zukunft jederzeit gerne wieder!
      </Typography>
      <Button onClick={hideBox} fullWidth>
        Nicht bewerten
      </Button>
    </ContentBox>
  );
}
